<template>
  <div class="warn-types none-height d-flex flex-column flex-grow-1">
    <div
      class="selector-container d-flex section-container"
      :class="{ dark: skinType }"
    >
      <SectionTitle title="系统日志"></SectionTitle>
      <el-form :inline="true" style="text-align: left" size="small">
        <el-form-item label="关键字" :class="{ 'light-label': skinType }">
          <el-input v-model="keywords" placeholder="关键字"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">查询</el-button>
          <el-button @click="exportTable">导出</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-table
      size="small"
      :data="tableData"
      class="none-height flex-grow-1"
      style="width: 100%"
      height="0"
      ref="table"
      row-key="TabID"
      stripe
            default-expand-all
      :tree-props="{ children: 'children' }"
      :class="{ dark: skinType }"
      :row-class-name="
        (...nu) => {
          return skinType ? 'dark text-white' : '';
        }
      "
      @row-click="rowClickListener"
    >
      <el-table-column fixed type="index" width="60" label="#">
      </el-table-column>
      <el-table-column prop="F_Date" label="日期" min-width="140"></el-table-column>
      <el-table-column prop="F_Account" label="账户" width="150">
      </el-table-column>
      <el-table-column prop="F_NickName" label="姓名" width="100">
      </el-table-column>
      <el-table-column prop="F_ModuleName" label="操作菜单" width="150">
      </el-table-column>
      <el-table-column prop="F_Type" label="操作类型" width="150">
      </el-table-column>
      <el-table-column prop="F_IPAddress" label="IP地址" width="120">
      </el-table-column>
      <el-table-column prop="F_Description" label="日志内容" min-width="200">
      </el-table-column>
    </el-table>
    <div
      class="d-flex section-container"
      style="padding: 1rem"
      :class="{ dark: skinType }"
    >
      <el-pagination
        v-if="pageInfo.total"
        style="margin-left: auto"
        background
        :class="{ 'text-white': skinType }"
        layout="total, prev, pager, next"
        :total="pageInfo.total"
        :current-page.sync="pageIndex"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import SectionTitle from '@/components/utils/section-title.vue';
import { getSystemLogs, clearSystemLog } from '@/api/system-safety/index';
import { exportExcel } from '@/utils/utils';
import { showConfirm } from '@/utils/dialog';

export default {
  name: 'warn-types',
  components: {
    SectionTitle,
  },
  data() {
    return {
      pageIndex: 1,
      pageInfo: {
        index: 1,
        size: 10,
        total: 1,
      },
      tableData: [],
      keywords: null,
      diaTitle: '',
      dialogVisible: false,
    };
  },
  created() {
    this.requestSystemLogs();
  },
  watch: {
    pageIndex() {
      this.requestSystemLogs();
    },
    // 申请时间
    keywords() {
      if (this.pageIndex !== 1) {
        this.pageIndex = 1;
        return;
      }
      this.requestSystemLogs();
    },
    // 申请类型
    applyClass() {
      if (this.pageIndex !== 1) {
        this.pageIndex = 1;
        return;
      }
      this.requestSystemLogs();
    },
  },
  computed: {
    skinType() {
      return this.$store.getters.skinType;
    },
  },
  methods: {
    onSubmit() {
      this.requestSystemLogs();
    },
    exportTable() {
      exportExcel(this.$refs.table.$el);
    },
    pageChangeListener(no) {
      this.pageIndex = no;
    },
    requestSystemLogs() {
      getSystemLogs({
        page: this.pageIndex,
        rows: this.pageInfo.size,
        keyword: this.keywords,
      }).then((res) => {
        this.tableData = res.rows || res;
        this.pageInfo.total = res.total || 0;
      });
    },
    rowClickListener(row) {
      console.log(row);
    },
    // 删除
    handleDelete(type) {
      const formData = new FormData();
      formData.append('keyValue', type.F_Id);
      showConfirm('告警大类', () => clearSystemLog(formData), this).then(this.requestSystemLogs);
    },
  },
};
</script>

<style scoped>

</style>
